import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import { PrivateRoute } from './components/PrivateRoute';
import { AdminRoute } from './components/AdminRoute';
import { LandingPage } from './pages/LandingPage';
import { AuthPage } from './pages/AuthPage';
import { ProjectsPage } from './pages/ProjectsPage';
import { EditorPage } from './pages/EditorPage';
import { AdminPage } from './pages/AdminPage';
import { ShareAcceptPage } from './pages/ShareAcceptPage';
import { FAQPage } from './pages/FAQPage';
import { AssistancePage } from './pages/AssistancePage';
import { VersionWatcher } from './components/VersionWatcher';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <VersionWatcher>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/auth" element={<AuthPage />} />
              <Route path="/share/:shareId" element={<ShareAcceptPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route
                path="/admin"
                element={
                  <AdminRoute>
                    <AdminPage />
                  </AdminRoute>
                }
              />
              <Route
                path="/projects"
                element={
                  <PrivateRoute>
                    <ProjectsPage />
                  </PrivateRoute>
                }
              />
              <Route
                path="/assistance"
                element={
                  <PrivateRoute>
                    <AssistancePage />
                  </PrivateRoute>
                }
              />
              <Route path="/project/:projectId" element={<EditorPage />} />
            </Routes>
          </VersionWatcher>
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
